export interface ActionStyle {
    icon: string;
    iconFilled: string;
    class: string;
    bgFromText: string;
    iconClass?: string;
}

export function getActionStyle(action: string): ActionStyle {
    switch (action) {
        case 'PICKUP':
            return {
                icon: 'system-deployed-code-2',
                iconFilled: 'system-deployed-code-filled',
                class: 'text-[#1E40AF] bg-muval-blue-2',
                bgFromText: 'bg-[#1E40AF]',
            };
        case 'WHOLE_MOVE':
            return {
                icon: 'system-truck',
                iconFilled: 'system-truck',
                class: 'text-[#1E40AF] bg-muval-blue-2',
                bgFromText: 'bg-[#1E40AF]',
            };
        case 'DELIVERY':
            return {
                icon: 'system-home-outline',
                iconFilled: 'system-home-filled',
                class: 'text-muval-red-1 bg-muval-red-2',
                bgFromText: 'bg-muval-red-1',
            };
        case 'YARD_WORK':
            return {
                icon: 'system-warehouse',
                iconFilled: 'system-warehouse-filled',
                class: 'text-muval-green-1 bg-muval-green-2',
                bgFromText: 'bg-muval-green-1',
            };
        case 'RAIL_PICKUP':
            return {
                icon: 'system-train',
                iconFilled: 'system-train-filled',
                class: 'text-muval-purple-1 bg-muval-purple-2',
                bgFromText: 'bg-muval-purple-1',
            };
        case 'RAIL_DELIVERY':
            return {
                icon: 'system-train',
                iconFilled: 'system-train-filled',
                class: 'text-[#9A3412] bg-[#FFEDD5]',
                bgFromText: 'bg-[#9A3412]',
            };
        case 'TRANSIT':
            return {
                icon: 'system-transit-2',
                iconFilled: 'system-transit-2-filled',
                class: 'text-[#854D0E] bg-muval-yellow-2',
                bgFromText: 'bg-[#854D0E]',
            };
        case 'PACKING':
            return {
                icon: 'system-box-outline',
                iconFilled: 'system-box-filled',
                class: 'text-[#155E75] bg-[#CFFAFE]',
                bgFromText: 'bg-[#155E75]',
            };
        case 'UNPACKING':
            return {
                icon: 'system-orders',
                iconFilled: 'system-orders-filled',
                class: 'text-muval-pink-1 bg-muval-pink-2',
                bgFromText: 'bg-muval-pink-1',
            };
        case 'PET_PICKUP':
            return {
                icon: 'system-pet-outline',
                iconFilled: 'system-pet-filled',
                class: 'text-muval-brown-1 bg-muval-brown-2',
                bgFromText: 'bg-muval-brown-1',
            };
        case 'PET_DELIVERY':
            return {
                icon: 'system-pet-outline',
                iconFilled: 'system-pet-filled',
                class: 'text-muval-green-1 bg-muval-green-2',
                bgFromText: 'bg-muval-green-1',
            };
        case 'VEHICLE_PICKUP':
            return {
                icon: 'system-car-outline',
                iconFilled: 'system-car-filled',
                class: 'text-muval-lime-1 bg-muval-lime-2',
                bgFromText: 'bg-muval-lime-1',
            };
        case 'VEHICLE_DELIVERY':
            return {
                icon: 'system-car-outline',
                iconFilled: 'system-car-filled',
                class: 'text-muval-dusk-2 bg-muval-purple-2',
                bgFromText: 'bg-muval-dusk-2',
            };
        case 'VEHICLE_DEPOT_PICKUP':
            return {
                icon: 'system-arrow-outward',
                iconFilled: 'system-arrow-outward',
                iconClass: '-rotate-225',
                class: 'text-muval-yellow-1 bg-muval-yellow-2',
                bgFromText: 'bg-muval-yellow-1',
            };
        case 'VEHICLE_DEPOT_DELIVERY':
            return {
                icon: 'system-arrow-outward',
                iconFilled: 'system-arrow-outward',
                iconClass: 'rotate-90',
                class: 'text-[#AE4D72] bg-[#FECFEE6E]',
                bgFromText: 'bg-[#AE4D72]',
            };
        case 'MISCELLANEOUS':
            return {
                icon: 'system-MISC',
                iconFilled: 'system-MISC',
                class: 'text-[#57534E] bg-[#F5F5F4]',
                bgFromText: 'bg-[#57534E]',
            };
        case 'PACKING_MATERIALS_DELIVERY':
            return {
                icon: 'system-tape',
                iconFilled: 'system-tape-filled',
                class: 'text-[#FF4D80] bg-[#FFEEF8]',
                bgFromText: 'bg-[#FF4D80]',
            };
        case 'BUG_SPRAY':
            return {
                icon: 'system-bug',
                iconFilled: 'system-tape-filled',
                class: 'text-[#079D83] bg-[#DFF2F9]',
                bgFromText: 'bg-[#079D83]',
            };
        case 'FUMIGATION':
            return {
                icon: 'system-hvac',
                iconFilled: 'system-hvac',
                class: 'text-[#D0630A] bg-[#F5FFAA]',
                bgFromText: 'bg-[#D0630A]',
            };
        case 'CLIENT_ACCESS':
            return {
                icon: 'system-key',
                iconFilled: 'system-key',
                class: 'text-[#D53E4D] bg-[#F7EAFF]',
                bgFromText: 'bg-[#D53E4D]',
            };
        case 'QUARANTINE':
            return {
                icon: 'system-medical-mask',
                iconFilled: 'system-medical-mask',
                class: 'text-[#FF0026] bg-[#FFEFEF]',
                bgFromText: 'bg-[#FF0026]',
            };
        case 'STORAGE':
        case 'END_STORAGE':
            return {
                icon: 'system-end-storage',
                iconFilled: 'system-end-storage',
                class: 'text-[#504E4C] bg-[#DFDBD3]',
                bgFromText: 'bg-[#504E4C]',
            };
        case 'MAINTENANCE':
            return {
                icon: 'system-spanner',
                iconFilled: 'system-spanner',
                class: 'text-[#075269] bg-[#EDEFF5]',
                bgFromText: 'bg-[#075269]',
            };
        case 'CLEAN':
            return {
                icon: 'system-spray',
                iconFilled: 'system-spray',
                class: 'text-[#1245FF] bg-[#FEFFEE]',
                bgFromText: 'bg-[#1245FF]',
            };
        case 'MOVEMENT':
            return {
                icon: 'system-pallet',
                iconFilled: 'system-pallet',
                class: 'text-[#658911] bg-[#ECF1ED]',
                bgFromText: 'bg-[#658911]',
            };
        default:
            return {
                icon: 'system-help',
                iconFilled: 'system-help',
                class: 'text-gray-500 bg-gray-200',
                bgFromText: 'bg-gray-500',
            };
    }
}
